import { getApiClient } from './AxiosService'
import Constants from '../constants/Api'

async function loginService(username, password) {
  const data = { korisnicko_ime: username, lozinka: password }
  try {
    const result = await getApiClient().post('korisnik/login', data)
    if (!Constants.IS_PRODUCTION) console.log('login service: ', result)
    if (result.status === 200 && result.data && result.data.success) {
      return {
        isOk: true,
        data: result.data.data,
        token: result.data.token,
        favourites: result.data.favourites,
      }
    } else if (result.status === 401 && result.data.code === 401) {
      return {
        isOk: false,
        message: result.data.error,
      }
    } else {
      return {
        isOk: false,
        message: '',
      }
    }
  } catch (error) {
    let response = {
      isOk: false,
      mesage: error.message,
    }
    if (error?.response?.status === 401) {
      response.message = error.response.data.error
    }
    return response
  }
}

async function registerService(data) {
  try {
    const result = await getApiClient().post('korisnik/register', data)
    if (result.data && result.data.success) {
      return {
        isOk: true,
        data: result.data.user,
        token: result.data.token,
      }
    }
  } catch (error) {
    // console.log('register service error: ', error)
    return {
      isOk: false,
      message: error.message,
    }
  }
}

async function updateUserService(data) {
  try {
    const result = await getApiClient(data.accessToken).put('korisnik', data)
    if (result.status === 200 && result.data.success) {
      return {
        isOk: true,
        data: result.data.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška!',
      }
    }
  } catch (error) {
    return {
      isOk: false,
      message: error.message,
    }
  }
}

async function getAllUsers() {
  try {
    const result = await getApiClient().get('korisnici')
    if (result.data && result.data.success) {
      return {
        isOk: true,
        data: result.data.data,
      }
    }
  } catch (error) {
    return {
      isOk: false,
      message: error.message,
    }
  }
}

async function verifyEmailService(data) {
  try {
    const result = await getApiClient().post('verify-email', data)
    if (result.data && result.data.success) {
      return {
        isOk: true,
        data: result.data.data,
      }
    }
  } catch (error) {
    return {
      isOk: false,
      message: error.message,
    }
  }
}

async function sendEmailForForgotPasswordService(data) {
  try {
    const result = await getApiClient().post('forgot-password', data)
    if (result.data && result.data.success) {
      return {
        isOk: true,
      }
    } else if (result.data && result.data.success === false) {
      return {
        isOk: false,
        message: result.data.message,
      }
    }
  } catch (error) {
    return {
      isOk: false,
      message: error.message,
    }
  }
}

async function resetPasswordService(data) {
  try {
    const result = await getApiClient().post('reset-password', data)

    if (result.data && result.data.success) {
      return {
        isOk: true,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška.',
      }
    }
  } catch (error) {
    return {
      isOk: false,
      message: error.message,
    }
  }
}

async function askForMailVerificationService(data) {
  try {
    const result = await getApiClient(
      data.accessToken
    ).post('ask-mail-verification', { email: data.email })
    if (result.status === 200) {
      return {
        isOk: true,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška!',
      }
    }
  } catch (error) {
    return {
      isOk: false,
      message: error.message,
    }
  }
}

export {
  loginService,
  updateUserService,
  registerService,
  getAllUsers,
  verifyEmailService,
  sendEmailForForgotPasswordService,
  resetPasswordService,
  askForMailVerificationService,
}
